import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0385d0ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "submitForm"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "color_666"
}, "人员可使用联系电话在管理端进行登录，默认密码为“A123456”", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_OrganizeSelect = _resolveComponent("OrganizeSelect");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_Eldialog = _resolveComponent("Eldialog");
  const _component_CourseFormDialog = _resolveComponent("CourseFormDialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Eldialog, _mergeProps(_ctx.$attrs, {
    visible: _ctx.show,
    "onUpdate:visible": _cache[13] || (_cache[13] = $event => _ctx.show = $event),
    title: _ctx.title,
    onConfirmOk: _ctx.onConfirm,
    width: "600px"
  }), {
    form: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
      ref: "ruleForm",
      "validate-on-rule-change": false,
      rules: _ctx.rules,
      model: _ctx.formData,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "管理者名称",
        prop: "teacherName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.formData.teacherName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.formData.teacherName = $event),
          placeholder: "请输入管理者名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "性别",
        required: "",
        prop: "sex"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          modelValue: _ctx.formData.sex,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.formData.sex = $event),
          label: 0
        }, {
          default: _withCtx(() => [_createTextVNode("未知")]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
          modelValue: _ctx.formData.sex,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.formData.sex = $event),
          label: 1
        }, {
          default: _withCtx(() => [_createTextVNode("男")]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
          modelValue: _ctx.formData.sex,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.formData.sex = $event),
          label: 2
        }, {
          default: _withCtx(() => [_createTextVNode("女")]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "联系电话",
        prop: "phone"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.formData.phone,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.formData.phone = $event),
          placeholder: "请输入联系电话"
        }, null, 8, ["modelValue"]), _hoisted_2]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "所属单位",
        prop: "schoolId"
      }, {
        default: _withCtx(() => [_createVNode(_component_OrganizeSelect, {
          modelValue: _ctx.searchValue,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.searchValue = $event),
          activeValue: _ctx.activeValue,
          type: 1,
          isSpecify: 'school',
          isDoubleClick: true,
          isClick: false,
          placeholder: "请输入单位",
          onHandleDoubleClick: _ctx.handleDoubleClick
        }, null, 8, ["modelValue", "activeValue", "onHandleDoubleClick"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "管理类型",
        prop: "type",
        required: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          modelValue: _ctx.formData.type,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.formData.type = $event),
          label: 1
        }, {
          default: _withCtx(() => [_createTextVNode("部门经理")]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
          modelValue: _ctx.formData.type,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.formData.type = $event),
          label: 2
        }, {
          default: _withCtx(() => [_createTextVNode("部门组长")]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
          modelValue: _ctx.formData.type,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.formData.type = $event),
          label: 3
        }, {
          default: _withCtx(() => [_createTextVNode("人力资源")]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _ctx.formData.type === 2 && _ctx.formData.schoolId !== null ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "管理岗位类型",
        required: "",
        prop: "chargeClassIds"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: _ctx.chargeClassIds,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.chargeClassIds = $event),
          placeholder: "请选择管理岗位类型",
          "show-all-levels": false,
          options: _ctx.classOptions,
          props: _ctx.props,
          "collapse-tags": true,
          clearable: ""
        }, null, 8, ["modelValue", "options", "props"])]),
        _: 1
      })) : _createCommentVNode("", true), _ctx.formData.schoolId !== null ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: "管理任务",
        prop: "courseIds",
        required: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.formData.courseIds,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.formData.courseIds = $event),
          multiple: "",
          placeholder: "请输入管理任务"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseOptions, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.courseId,
              label: item.courseName,
              value: item.courseId
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("span", {
          class: "addClass",
          onClick: _cache[11] || (_cache[11] = $event => _ctx.addCourse())
        }, "新增日常任务")]),
        _: 1
      })) : _createCommentVNode("", true), _ctx.formData.schoolId !== null ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 2,
        label: "管理岗位类型",
        prop: "classIds",
        required: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: _ctx.classIds,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _ctx.classIds = $event),
          placeholder: "请选择管理岗位类型",
          "show-all-levels": true,
          options: _ctx.classOptions,
          props: _ctx.props,
          "collapse-tags": "",
          clearable: ""
        }, null, 8, ["modelValue", "options", "props"])]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["rules", "model"])])]),
    footer: _withCtx(() => []),
    _: 1
  }, 16, ["visible", "title", "onConfirmOk"]), _createVNode(_component_CourseFormDialog, {
    visible: _ctx.courseVisible,
    "onUpdate:visible": _cache[14] || (_cache[14] = $event => _ctx.courseVisible = $event),
    schoolInfo: _ctx.schoolInfo,
    onHandleSuccess: _cache[15] || (_cache[15] = $event => _ctx.courseHandleSuccess())
  }, null, 8, ["visible", "schoolInfo"])], 64);
}